import { uniq } from 'utils/filterUtils';

export const getMostUsedTargetLanguagesUtil = (languagePairs: string[], removeTq = false) => {
  if (!languagePairs.length) return removeTq ? [] : ['tq'];

  return languagePairs.map((codes) => codes?.split('-')[1]).filter(uniq);
};
